import { render, staticRenderFns } from "./FeedbackTable.vue?vue&type=template&id=5f3b5552&scoped=true&"
import script from "./FeedbackTable.vue?vue&type=script&lang=ts&"
export * from "./FeedbackTable.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackTable.vue?vue&type=style&index=0&id=5f3b5552&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3b5552",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import GFaIcon from 'shared/global/components/FaIcon.vue'
import GOverflowTooltip from 'shared/global/components/OverflowTooltip.vue'
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {GFaIcon,GOverflowTooltip,VBtn,VDataTable})
